import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { trackSpinStarted } from "@/lib/pixel";

const HERO_IMG =
  "https://images.unsplash.com/photo-1762195340046-415140d8b1b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwd2hpdGUlMjBsdXh1cnklMjBjYXIlMjBzdHVkaW8lMjBsaWdodGluZ3xlbnwwfHx8fDE3ODEwNTk1ODN8MA&ixlib=rb-4.1.0&q=85";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

const onSpinCta = (source) => {
  trackSpinStarted({ source });
  scrollTo("spin");
};

const TRUST_ITEMS = [
  "⭐ 4.8 Google Rating",
  "5,000+ Cars Serviced",
  "All Brands",
  "100% Genuine Parts Guarantee",
];

export default function Hero() {
  return (
    <header className="bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-12 sm:pt-20 pb-14 sm:pb-24 grid lg:grid-cols-[1.05fr_1fr] gap-10 lg:gap-16 items-center">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-xs uppercase tracking-[0.25em] text-[#FF5A00] font-bold mb-5"
          >
            AutoHQ · Ranigunj, Hyderabad
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 }}
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tighter text-[#0A0A0A] leading-[1.04]"
          >
            Hyderabad's Most Trusted Multi-Brand Car Service —{" "}
            <span className="text-[#FF5A00]">Ranigunj</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.16 }}
            className="mt-6 text-base md:text-lg text-[#52525B] max-w-xl leading-relaxed"
          >
            100% genuine parts — never white-labeled or duplicate. Transparent
            pricing. Insurance claims handled end-to-end.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.22 }}
            className="mt-5 inline-flex items-center gap-2 rounded-sm border border-[#0A0A0A] bg-[#FAFAFA] px-3 py-1.5"
            data-testid="hero-grand-prize-badge"
          >
            <span aria-hidden className="inline-block w-1.5 h-1.5 rounded-full bg-[#D4AF37] animate-pulse" />
            <span className="text-[10px] sm:text-[11px] uppercase tracking-[0.2em] font-bold text-[#0A0A0A]">
              Spin &amp; Win — <span className="text-[#D4AF37]">FREE service worth ₹5,000</span>
            </span>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.24 }}
            className="mt-9 flex flex-col sm:flex-row gap-4"
          >
            <Button
              data-testid="hero-spin-cta"
              onClick={() => onSpinCta("hero_cta")}
              className="bg-[#FF5A00] hover:bg-[#E04F00] text-white font-bold text-base px-8 py-6 rounded-sm transition-transform hover:-translate-y-0.5"
            >
              🎡 Spin &amp; Win — Free
            </Button>
            <Button
              data-testid="hero-callback-cta"
              onClick={() => scrollTo("callback")}
              variant="outline"
              className="border-[#E4E4E7] bg-white text-[#0A0A0A] hover:border-[#0A0A0A] hover:bg-white hover:text-[#0A0A0A] text-base px-8 py-6 rounded-sm"
            >
              Request a Callback
            </Button>
          </motion.div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
          className="relative"
        >
          <img
            src={HERO_IMG}
            alt="Premium car care at AutoHQ"
            className="w-full h-[280px] sm:h-[440px] object-cover rounded-sm border border-[#E4E4E7]"
          />
          <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur border border-[#E4E4E7] rounded-sm px-4 py-2.5 text-[11px] font-bold tracking-[0.15em] uppercase text-[#0A0A0A]">
            100% Genuine Parts · Zero Compromise
          </div>
        </motion.div>
      </div>

      {/* Trust bar */}
      <div className="border-y border-[#E4E4E7] bg-[#FAFAFA] py-3.5 overflow-hidden" data-testid="trust-bar">
        <div className="marquee-track">
          {[...TRUST_ITEMS, ...TRUST_ITEMS, ...TRUST_ITEMS, ...TRUST_ITEMS].map((item, i) => (
            <span
              key={i}
              className="mx-8 text-xs uppercase tracking-[0.2em] font-semibold text-[#52525B] whitespace-nowrap"
            >
              {item} <span className="text-[#FF5A00] ml-8">·</span>
            </span>
          ))}
        </div>
      </div>
    </header>
  );
}
